export { TextArea } from "./TextArea";
export type { IProps } from "./TextArea";
